import React from 'react';
import { useDocumentStats } from '../../hooks/document/useDocumentStats';

function SigningProgressChart() {
  const { completed, total, isLoading } = useDocumentStats();

  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;
  const circumference = 2 * Math.PI * 60; // radius = 60 (increased from 45)
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  if (isLoading) {
    return (
      <div className="px-4 py-4 border-t border-gray-200">
        <div className="flex items-center justify-center">
          <div className="animate-pulse text-sm text-gray-400">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="px-4 py-6 border-t border-gray-200 bg-gray-50/50">
      <div className="text-sm font-semibold text-gray-700 mb-4 text-center">
        Document Signing Progress
      </div>
      
      {/* Circular Progress Chart - Centered and Larger */}
      <div className="flex items-center justify-center">
        <div className="relative flex-shrink-0">
          <svg className="transform -rotate-90" width="140" height="140">
            {/* Background circle */}
            <circle
              cx="70"
              cy="70"
              r="60"
              stroke="currentColor"
              strokeWidth="10"
              fill="none"
              className="text-gray-200"
            />
            {/* Progress circle */}
            <circle
              cx="70"
              cy="70"
              r="60"
              stroke="currentColor"
              strokeWidth="10"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              className="text-blue-500 transition-all duration-500"
            />
          </svg>
          {/* Percentage text in center */}
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-2xl font-semibold text-gray-700">{percentage}%</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SigningProgressChart;

